export const errorHandler = (err, vm, info) => {
  console.log(err, vm, info);
};
